export const EVENT_LANG_CHANGE = 'app:languagePicker@change';
export const EVENT_LANG_CHANGE_SIDEBAR = 'app:languagePicker@change(sidebar)';
export const EVENT_CART_COUNT_UPDATE = 'app:cart@updateCount';
export const EVENT_CART_FETCH = 'app:cart@fetch';
export const EVENT_SEARCH = 'app:search@trigger';
export const EVENT_TOKEN_REFRESHED = 'app:auth@tokenRefreshed';
export const EVENT_MEDIA_SELECT_FILE = 'media::toggleFileSelection';
export const EVENT_MEDIA_PREVIEW_IMAGE = 'media::previewImage';
export const EVENT_MEDIA_RESTRICT = 'media::openRestrictModal';
export const EVENT_MEDIA_RESTRICT_CLOSE = 'media::closeRestrictModal';
export const EVENT_MEDIA_RESTRICT_CHANGED = 'media::updateRestriction';
